// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, nullOrUndefined, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdCustomEventsSettingsCreateResult = objectOf({
  info: string,
  analytics_report_custom_events: arrayOf(nullOrUndefined),
  resubscribe_on_changed_email: boolean,
  add_list_unsubscribe_header: boolean,
  override_email_open_tracking_pixel_to_top: objectOf({}),
  email_use_custom_footer: boolean,
  email_custom_footer: string,
  email_plaintext_footer: nullOrUndefined,
  email_footer_size_grandfathered: nullOrUndefined,
  email_use_custom_unsubscribe_page: boolean,
  email_custom_unsubscribe_page: string,
  email_use_custom_opt_in_page: boolean,
  email_custom_opt_in_page: string,
  email_opt_in_size_grandfathered: nullOrUndefined,
  app_type: string,
  set_badge_count_on_push: boolean,
  image_upload_data: objectOf({
    image_name: string,
    image_url: string,
  }),
  name: string,
  api_key: string,
  sdk_version: nullOrUndefined,
  sdk_api_host: string,
  sdk_is_up_to_date: boolean,
  sdk_version_can_uninstall_track: boolean,
  uninstall_tracking_enabled: boolean,
  uninstall_tracking_last_ran_at: number,
  sdk_version_supports_geofences: boolean,
  geofences_enabled: nullOrUndefined,
  any_apps_with_uninstall_tracking: boolean,
});
